import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { createElement } from "react";
import { publicLoader } from "./loader";
import { apiRunner } from "./api-runner-browser";
import { grabMatchParams } from "./find-path";

// Renders page
let PageRenderer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageRenderer, _React$Component);
  function PageRenderer() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = PageRenderer.prototype;
  _proto.render = function render() {
    const props = {
      ...this.props,
      params: {
        ...grabMatchParams(this.props.location.pathname),
        ...this.props.pageResources.json.pageContext.__params
      },
      pathContext: this.props.pageContext
    };
    const [replacementElement] = apiRunner(`replaceComponentRenderer`, {
      props: this.props,
      loader: publicLoader
    });
    const pageElement = replacementElement || /*#__PURE__*/createElement(this.props.pageResources.component, {
      ...props,
      key: this.props.path || this.props.pageResources.page.path
    });
    const wrappedPage = apiRunner(`wrapPageElement`, {
      element: pageElement,
      props
    }, pageElement, _ref => {
      let {
        result
      } = _ref;
      return {
        element: result,
        props
      };
    }).pop();
    return wrappedPage;
  };
  return PageRenderer;
}(React.Component);
export default PageRenderer;